//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.0.0 (NJsonSchema v11.6.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://az-api-dev.ractest.com.au/insurance/caravan/api/v1";
    }

    /**
     * DeleteMatchedContactFromSession
     * @return Matched contact details successfully deleted from session
     */
    deletematchedcontactfromsession(): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/contacts/match";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletematchedcontactfromsession(_response);
        });
    }

    protected processDeletematchedcontactfromsession(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * MatchContact
     * @param matchContact (optional) The details used to match against a contact.
     * @return Match was successful
     */
    matchcontact(matchContact?: MatchContact | null | undefined): Promise<ApiResponse<MatchedContactDetails>> {
        let url_ = this.baseUrl + "/contacts/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchContact);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMatchcontact(_response);
        });
    }

    protected processMatchcontact(response: Response): Promise<ApiResponse<MatchedContactDetails>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MatchedContactDetails;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Match not found.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Ambiguous matches.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<MatchedContactDetails>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetManufacturers
     * @return List of insurable caravan or trailer manufacturers.
     */
    getmanufacturers(): Promise<ApiResponse<Manufacturer[]>> {
        let url_ = this.baseUrl + "/caravans/manufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetmanufacturers(_response);
        });
    }

    protected processGetmanufacturers(response: Response): Promise<ApiResponse<Manufacturer[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Manufacturer[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Manufacturer[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetPaymentReferenceData
     * @return The related reference data required for payments
     */
    getpaymentreferencedata(): Promise<ApiResponse<PaymentReferenceData>> {
        let url_ = this.baseUrl + "/referencedata/payment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetpaymentreferencedata(_response);
        });
    }

    protected processGetpaymentreferencedata(response: Response): Promise<ApiResponse<PaymentReferenceData>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentReferenceData;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<PaymentReferenceData>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetOvernightParkingOptions
     * @return The list of overnight parking options.
     */
    getovernightparkingoptions(): Promise<ApiResponse<ReferenceDataOption[]>> {
        let url_ = this.baseUrl + "/referencedata/overnightparking";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetovernightparkingoptions(_response);
        });
    }

    protected processGetovernightparkingoptions(response: Response): Promise<ApiResponse<ReferenceDataOption[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReferenceDataOption[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<ReferenceDataOption[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * EmailQuote
     * @param emailQuoteRequest (optional) The details of the quote to be saved and emailed.
     * @return No content
     */
    emailquote(emailQuoteRequest?: EmailQuoteRequest | null | undefined): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/quote/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailQuoteRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailquote(_response);
        });
    }

    protected processEmailquote(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetHealthStatus
     * @return No content
     */
    gethealthstatus(): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/health/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGethealthstatus(_response);
        });
    }

    protected processGethealthstatus(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * UpdateMembershipTier
     * @param updateMembershipTierRequest (optional) The membership tier.
     * @return The premium details of the updated quote.
     */
    updatemembershiptier(updateMembershipTierRequest?: UpdateMembershipTierRequest | null | undefined): Promise<ApiResponse<UpdateMembershipTierResponse>> {
        let url_ = this.baseUrl + "/membershiptier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateMembershipTierRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatemembershiptier(_response);
        });
    }

    protected processUpdatemembershiptier(response: Response): Promise<ApiResponse<UpdateMembershipTierResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateMembershipTierResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<UpdateMembershipTierResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * RetrieveQuote
     * @param quoteNumber The unique number for the quote
     * @param suburbName The suburb name
     * @param postcode The postal code for the suburb of the associate quote
     * @return Caravan quote was found.
     */
    retrievequote(quoteNumber: string, suburbName: string, postcode: number): Promise<ApiResponse<RetrieveQuoteResponse>> {
        let url_ = this.baseUrl + "/retrievequote?";
        if (quoteNumber === undefined || quoteNumber === null)
            throw new globalThis.Error("The parameter 'quoteNumber' must be defined and cannot be null.");
        else
            url_ += "quoteNumber=" + encodeURIComponent("" + quoteNumber) + "&";
        if (suburbName === undefined || suburbName === null)
            throw new globalThis.Error("The parameter 'suburbName' must be defined and cannot be null.");
        else
            url_ += "suburbName=" + encodeURIComponent("" + suburbName) + "&";
        if (postcode === undefined || postcode === null)
            throw new globalThis.Error("The parameter 'postcode' must be defined and cannot be null.");
        else
            url_ += "postcode=" + encodeURIComponent("" + postcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRetrievequote(_response);
        });
    }

    protected processRetrievequote(response: Response): Promise<ApiResponse<RetrieveQuoteResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RetrieveQuoteResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Caravan quote was not found.", status, _responseText, _headers);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too many requests for the caravan quote have been made.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<RetrieveQuoteResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetPersonalInformationReferenceData
     * @return The Personal Information Reference Data that includes mailing address.
     */
    getpersonalinformationreferencedata(): Promise<ApiResponse<PersonalInformationReferenceData>> {
        let url_ = this.baseUrl + "/personalinformation/reference-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetpersonalinformationreferencedata(_response);
        });
    }

    protected processGetpersonalinformationreferencedata(response: Response): Promise<ApiResponse<PersonalInformationReferenceData>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonalInformationReferenceData;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<PersonalInformationReferenceData>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * CreateSession
     * @return Session creation was successful
     */
    createsession(): Promise<ApiResponse<string>> {
        let url_ = this.baseUrl + "/session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatesession(_response);
        });
    }

    protected processCreatesession(response: Response): Promise<ApiResponse<string>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<string>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * Payment
     * @param paymentRequest (optional) Issue the policy in Shield for payment
     * @return Issue policy using payment method was successful
     */
    payment(paymentRequest?: PaymentRequest | null | undefined): Promise<ApiResponse<PaymentResponse>> {
        let url_ = this.baseUrl + "/payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPayment(_response);
        });
    }

    protected processPayment(response: Response): Promise<ApiResponse<PaymentResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponse;
            return new ApiResponse(status, _headers, result201);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponse;
            return new ApiResponse(status, _headers, result204);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponse;
            return throwException("Service is/was unavailable during payment. Requests may be retried again (with presence of Retry-After header).", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<PaymentResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetSessionExpiry
     * @return Session expiry in seconds retrieved successfully
     */
    getsessionexpiry(): Promise<ApiResponse<string>> {
        let url_ = this.baseUrl + "/session/expiry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetsessionexpiry(_response);
        });
    }

    protected processGetsessionexpiry(response: Response): Promise<ApiResponse<string>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 408) {
            return response.text().then((_responseText) => {
            let result408: any = null;
            result408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Session expired", status, _responseText, _headers, result408);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<string>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * ContactMatchAttemptsExhausted
     * @return The device still allowed to try again a contact match.
     */
    contactmatchattemptsexhausted(): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/areyouamember/contact-match/attempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContactmatchattemptsexhausted(_response);
        });
    }

    protected processContactmatchattemptsexhausted(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too many requests.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * UpdateContactDetails
     * @param updateContactDetailsRequest (optional) The contact details.
     * @return The cover details of the updated quote.
     */
    updatecontactdetails(updateContactDetailsRequest?: UpdateContactDetailsRequest | null | undefined): Promise<ApiResponse<UpdateContactDetailsResponse>> {
        let url_ = this.baseUrl + "/personalinformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateContactDetailsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatecontactdetails(_response);
        });
    }

    protected processUpdatecontactdetails(response: Response): Promise<ApiResponse<UpdateContactDetailsResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateContactDetailsResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict, ambiguous matches.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<UpdateContactDetailsResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * UpdateQuoteCover
     * @param coverRequest (optional) The details of the quote cover to be updated.
     * @return The updated quote details.
     */
    updatequotecover(coverRequest?: CoverRequest | null | undefined): Promise<ApiResponse<Cover>> {
        let url_ = this.baseUrl + "/quote/cover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(coverRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatequotecover(_response);
        });
    }

    protected processUpdatequotecover(response: Response): Promise<ApiResponse<Cover>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Cover;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Cover>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * SaveQuote
     * @param quoteRequest (optional) The details of the quote to be saved.
     * @return The saved quote details.
     */
    savequote(quoteRequest?: QuoteRequest | null | undefined): Promise<ApiResponse<QuoteResponse>> {
        let url_ = this.baseUrl + "/quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSavequote(_response);
        });
    }

    protected processSavequote(response: Response): Promise<ApiResponse<QuoteResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<QuoteResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetAddresses
     * @param q The search term to apply onto the address to filter on.
     * @return The addresses matching the filter.
     */
    getaddresses(q: string): Promise<ApiResponse<AddressSummary[]>> {
        let url_ = this.baseUrl + "/addresses?";
        if (q === undefined || q === null)
            throw new globalThis.Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetaddresses(_response);
        });
    }

    protected processGetaddresses(response: Response): Promise<ApiResponse<AddressSummary[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressSummary[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<AddressSummary[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetCaravans
     * @param manufacturerCode The manufacturer code.
     * @param year The year of the model.
     * @param model The model code.
     * @return List of available insurable caravans for the specified caravan or trailer manufacturer, year and model.
     */
    getcaravans(manufacturerCode: string, year: number, model: string): Promise<ApiResponse<Caravan[]>> {
        let url_ = this.baseUrl + "/caravans/manufacturers/{manufacturerCode}/years/{year}/caravans?";
        if (manufacturerCode === undefined || manufacturerCode === null)
            throw new globalThis.Error("The parameter 'manufacturerCode' must be defined.");
        url_ = url_.replace("{manufacturerCode}", encodeURIComponent("" + manufacturerCode));
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (model === undefined || model === null)
            throw new globalThis.Error("The parameter 'model' must be defined and cannot be null.");
        else
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetcaravans(_response);
        });
    }

    protected processGetcaravans(response: Response): Promise<ApiResponse<Caravan[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Caravan[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No available insurable caravans have been found for the specified caravan or trailer manufacturer and year.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Caravan[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetMembershipLevels
     * @return The list of membership level options.
     */
    getmembershiplevels(): Promise<ApiResponse<ReferenceDataOption[]>> {
        let url_ = this.baseUrl + "/referencedata/membership-levels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetmembershiplevels(_response);
        });
    }

    protected processGetmembershiplevels(response: Response): Promise<ApiResponse<ReferenceDataOption[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReferenceDataOption[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<ReferenceDataOption[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetSuburbs
     * @return The WA Suburbs.
     */
    getsuburbs(): Promise<ApiResponse<Suburb[]>> {
        let url_ = this.baseUrl + "/referencedata/suburbs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetsuburbs(_response);
        });
    }

    protected processGetsuburbs(response: Response): Promise<ApiResponse<Suburb[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Suburb[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Suburb[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetNext
     * @return No content
     */
    getnext(): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/session/next";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetnext(_response);
        });
    }

    protected processGetnext(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetMnfctrsYrs
     * @param manufacturerCode The manufacturer code.
     * @return List of available model years for the specified caravan or trailer manufacturer.
     */
    getmnfctrsyrs(manufacturerCode: string): Promise<ApiResponse<number[]>> {
        let url_ = this.baseUrl + "/caravans/manufacturers/{manufacturerCode}/years";
        if (manufacturerCode === undefined || manufacturerCode === null)
            throw new globalThis.Error("The parameter 'manufacturerCode' must be defined.");
        url_ = url_.replace("{manufacturerCode}", encodeURIComponent("" + manufacturerCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetmnfctrsyrs(_response);
        });
    }

    protected processGetmnfctrsyrs(response: Response): Promise<ApiResponse<number[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No available model years have been found for the specified caravan or trailer manufacturer.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<number[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetModels
     * @param manufacturerCode The manufacturer code.
     * @param year The year of the model.
     * @return List of available insurable models for the specified caravan or trailer manufacturer and year.
     */
    getmodels(manufacturerCode: string, year: number): Promise<ApiResponse<Model[]>> {
        let url_ = this.baseUrl + "/caravans/manufacturers/{manufacturerCode}/years/{year}/models";
        if (manufacturerCode === undefined || manufacturerCode === null)
            throw new globalThis.Error("The parameter 'manufacturerCode' must be defined.");
        url_ = url_.replace("{manufacturerCode}", encodeURIComponent("" + manufacturerCode));
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetmodels(_response);
        });
    }

    protected processGetmodels(response: Response): Promise<ApiResponse<Model[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Model[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No available insurable models have been found for the specified caravan or trailer manufacturer and year.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Model[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * FurtherDetails
     * @param furtherDetailsRequest (optional) The policy details to update.
     * @return The cover details.
     */
    furtherdetails(furtherDetailsRequest?: FurtherDetailsRequest | null | undefined): Promise<ApiResponse<CoverSummary>> {
        let url_ = this.baseUrl + "/furtherdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(furtherDetailsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFurtherdetails(_response);
        });
    }

    protected processFurtherdetails(response: Response): Promise<ApiResponse<CoverSummary>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoverSummary;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<CoverSummary>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * FormotivModel
     * @param formotivModelRequest (optional) The details of the model to be run.
     * @return Run model ran successfully and returned model data.
     */
    formotivmodel(formotivModelRequest?: FormotivModelRequest | null | undefined): Promise<ApiResponse<FormotivModel>> {
        let url_ = this.baseUrl + "/formotiv/model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formotivModelRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFormotivmodel(_response);
        });
    }

    protected processFormotivmodel(response: Response): Promise<ApiResponse<FormotivModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormotivModel;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormotivModel;
            return throwException("Run model failed and returned no response model data.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<FormotivModel>>(new ApiResponse(status, _headers, null as any));
    }
}

/** Contains the details regarding the error. */
export interface ErrorDto {
    /** The error message. */
    message: string;
}

/** Contains the details regarding the reference data. */
export interface ReferenceData {
    /** The unique code corresponding to the reference data. */
    code: string;
    /** The name or description corresponding to the reference data. */
    name: string;
}

/** Contains the details regarding the manufacturer. */
export interface Manufacturer extends ReferenceData {
    /** A flag indicating whether the manufacturer is popular / common. */
    isPopular?: boolean | undefined;
}

/** Contains the details regarding the model. */
export interface Model extends ReferenceData {
}

/** Contains the details regarding the caravan. */
export interface Caravan {
    /** The identifier corresponding to the caravan. */
    id: number;
    /** The manufacturer (code) of the caravan. */
    manufacturerCode: string;
    /** The manufacturer (name) of the caravan. */
    manufacturer: string;
    /** The model (code) of the caravan. */
    modelCode: string;
    /** The model (name) of the caravan. */
    model: string;
    /** The model year of the caravan. */
    year: number;
    /** The full (name) description corresponding to the caravan. */
    description: string;
    /** The market value corresponding to the caravan. */
    marketValue: number;
}

/** A suburb in WA with postcode from Shield. */
export interface Suburb {
    /** The display name (Name - Postcode). */
    cityName: string;
    /** The suburb name. */
    name: string;
    /** The suburb postcode */
    postcode: string;
}

/** The generic reference data structure. */
export interface ReferenceDataOption {
    /** Reference data option external code. */
    externalCode: string;
    /** Reference data option description. */
    description: string;
}

/** The query parameters for matching a contact. */
export interface MatchContact {
    /** The first name of the contact. */
    firstName: string;
    /** The date of birth of the contact. */
    dateOfBirth: Date;
    /** The mobile number of the contact. */
    mobileNumber: string;
    /** The email address of the contact. */
    email: string;
}

/** The details of the matched contact. */
export interface MatchedContactDetails {
    /** The matched contacts membership tier. */
    membershipTier: string;
    /** The matched contact response status. */
    status: number;
}

/** The caravan or trailer details. */
export interface Asset {
    /** The registration number of the caravan. */
    registrationNumber?: string | undefined;
    /** The vehicle id. */
    vehicleId: number;
    /** The location of where the caravan or trailer or trailer is kept. */
    keptLocation: KeptLocation;
    /** The suburb where the caravan or trailer is kept. */
    suburb: string;
    /** The postcode of the suburb where the caravan or trailer is kept. */
    postcode: number;
    /** The market value of the caravan or trailer. */
    marketValue?: number | undefined;
}

/** The caravan or trailer details. */
export interface RetrieveAsset {
    /** The registration number of the caravan. */
    registrationNumber?: string | undefined;
    /** The vehicle id. */
    vehicleId: number;
    /** The location of where the caravan or trailer or trailer is kept. */
    keptLocation: KeptLocation;
    /** The suburb where the caravan or trailer is kept. */
    suburb: string;
    /** The postcode of the suburb where the caravan or trailer is kept. */
    postcode: number;
    /** The market value of the caravan or trailer. */
    marketValue?: number | undefined;
    /** The manufacturer Id of the caravan. */
    manufacturerId: string;
    /** The model Id of the caravan. */
    modelId: string;
    /** The model year of the caravan. */
    year: number;
}

/** The policyholder's details. */
export interface Policyholder {
    /** The first name of the policyholder. */
    firstName?: string | undefined;
    /** The middle name of the policyholder. */
    middleName?: string | undefined;
    /** The surname of the policyholder. */
    surname?: string | undefined;
    /** The date of birth of the policyholder. */
    dateOfBirth: Date;
    gender?: Gender | undefined;
    /** The email of the policyholder. */
    email?: string | undefined;
    title?: Title | undefined;
    /** The contacts phone number (could be landline or mobile). */
    contactNumber?: string | undefined;
    /** The policyholder's membership tier (Specify only for multi match). */
    membershipTier?: MembershipTier | undefined;
}

/** The policyholder's details. */
export interface RetrievePolicyholder {
    /** The first name of the policyholder. */
    firstName?: string | undefined;
    /** The middle name of the policyholder. */
    middleName?: string | undefined;
    /** The surname of the policyholder. */
    surname?: string | undefined;
    /** The date of birth of the policyholder. */
    dateOfBirth: Date;
    /** The email of the policyholder. */
    email?: string | undefined;
    title?: Title | undefined;
    /** The contacts phone number (could be landline or mobile). */
    contactNumber?: string | undefined;
}

export interface DateRange {
    /** The current value. */
    value: Date;
    /** The minimum allowed value. */
    min?: Date | undefined;
    /** The maximum allowed value. */
    max?: Date | undefined;
}

export interface NumberRange {
    /** The current value. */
    value: number;
    /** The minimum allowed value. */
    min?: number | undefined;
    /** The maximum allowed value. */
    max?: number | undefined;
}

export interface NumberOptions {
    /** The selected value or option. */
    value: number;
    /** The available set of options to select a value from. */
    options?: number[] | undefined;
}

export enum PolicyholderType {
    Main = "Main",
    Additional1 = "Additional1",
}

export enum MembershipTier {
    Gold = "Gold",
    Silver = "Silver",
    Bronze = "Bronze",
    Blue = "Blue",
    Red = "Red",
    Free2Go = "Free2Go",
    NotSure = "NotSure",
    NotAMember = "NotAMember",
}

export enum KeptLocation {
    Garage = "Garage",
    Carport = "Carport",
    Driveway = "Driveway",
    Street_or_Verge = "Street or Verge",
    Communal_Carpark = "Communal Carpark",
    OnSite = "On-Site",
}

/** The premium details. */
export interface PremiumDetails {
    /** The annual premium details. */
    annual: AnnualPremium;
    /** The monthly premium details. */
    monthly: MonthlyPremium;
}

/** The cost of premium for the selected risk/policy details. */
export interface Premium {
    /** The total amount including GST component. */
    total: number;
    /** The GST component. */
    gst: number;
    /** The basic component (Basic = Total - Gst - GovernmentCharges). */
    basic: number;
    /** The government charges (stamp duty) component. */
    governmentCharges: number;
}

/** The cost of annual premium for the selected risk/policy details. */
export interface AnnualPremium extends Premium {
}

/** The cost of premium for the selected risk/policy details. */
export interface MonthlyPremium extends Premium {
    /** The monthly instalment amount. */
    instalment: number;
}

export enum CoverType {
    Caravan = "Caravan",
    Trailer = "Trailer",
}

export enum PaymentFrequency {
    Annual = "Annual",
    Monthly = "Monthly",
}

export enum PaymentMethod {
    Card = "Card",
    Bank_account = "Bank account",
}

/** The cover details. */
export interface Cover {
    /** The cover type. */
    type: CoverType;
    /** The sum insured details. */
    sumInsured: NumberRange;
    /** The excess for the cover. */
    excess: NumberOptions;
    /** The premium details. */
    premiumDetails: PremiumDetails;
    /** The list of discounts for the quote. */
    discounts?: Discount[] | undefined;
}

/** The discount details. */
export interface Discount {
    /** Discount Type. */
    discountType: string;
    /** Discount Value. */
    discountValue?: number | undefined;
    /** Discount Percentage. */
    discountPercent?: number | undefined;
    /** Discount Description. */
    description: string;
}

/** The caravan cover details. */
export interface CaravanCover extends Cover {
    /** The contents sum insured. */
    contents: NumberRange;
}

/** The caravan cover details. */
export interface TrailerCover extends Cover {
}

/** Object to save a quote. */
export interface QuoteRequest {
    /** The promotion code to apply. */
    promotion?: string | undefined;
    /** The information of the caravan or trailer. */
    asset: Asset;
    /** The details of the policyholder(s). */
    policyholders: Policyholder[];
}

/** Object the details of the quote created or updated. */
export interface QuoteResponse {
    /** The quote number. */
    quoteNumber: string;
    /** The start date. */
    startDate: DateRange;
    /** The list of covers available for the quote. */
    covers: Cover[];
}

/** Object details of an existing quote. */
export interface RetrieveQuoteResponse {
    /** The frequency of the payment details. */
    paymentFrequency: PaymentFrequency;
    /** The details of the main policyholder. */
    mainPolicyholder: RetrievePolicyholder;
    /** The details of the additional policyholder. */
    additionalPolicyholder?: RetrievePolicyholder | undefined;
    /** The information of the caravan or trailer. */
    asset: RetrieveAsset;
    /** Denotes if there is more than 1 policyholder for the quote. */
    hasAdditionalPolicyholder: boolean;
    /** The quote number. */
    quoteNumber: string;
    /** The start date. */
    startDate: DateRange;
    /** The list of covers available for the quote. */
    covers: Cover[];
}

/** Object to update the policy details of a quote. */
export interface FurtherDetailsRequest {
    /** The start date of the policy. */
    startDate: Date;
}

/** The cover details. */
export interface CoverSummary {
    /** The cover type. */
    type: CoverType;
    /** The excess for the cover. */
    excess: NumberOptions;
    /** The premium details. */
    premiumDetails: PremiumDetails;
}

/** Object to create and update a cover. */
export interface CoverRequest {
    /** The cover type. */
    type: CoverType;
    /** The payment frequency. */
    frequency: PaymentFrequency;
    /** The excess amount for the cover. */
    excess: number;
    /** The sum insured details. */
    sumInsured: number;
    /** The sum insured details for contents cover. */
    contents?: number | undefined;
}

export interface EmailQuoteRequest extends CoverRequest {
    /** The email address to email the quote to. */
    email: string;
}

/** Contains the reference data that is required to populate the Personal Information form. */
export interface PersonalInformationReferenceData {
    /** Whether Title and Gender is required for the matched contact. */
    isTitleAndGenderRequired: boolean;
    /** Postal address from the contact matched. */
    postalAddress?: AddressSummary | undefined;
    /** The surname of the policyholder. */
    surname?: string | undefined;
    title?: Title | undefined;
    gender?: Gender | undefined;
}

/** Contains the address summary. */
export interface AddressSummary {
    /** The moniker representing the address. */
    moniker: string;
    /** The display text of the address. */
    displayAddress: string;
}

/** Request object to update a contact details. */
export interface UpdateContactDetailsRequest {
    title?: Title | undefined;
    gender?: Gender | undefined;
    /** The first name of the contact. */
    firstName?: string | undefined;
    /** The middle name of the policyholder. */
    middleName?: string | undefined;
    /** The contacts surname. */
    surname?: string | undefined;
    /** The contacts phone number (could be landline or mobile). */
    contactNumber?: string | undefined;
    /** The email address to email the quote to. */
    email?: string | undefined;
    /** The moniker representing the address. */
    mailingAddress: string;
    /** The policyholder type. */
    policyholderType?: PolicyholderType | undefined;
}

/** Contains the response details regarding the updated quote details. */
export interface UpdateContactDetailsResponse extends PremiumDetails {
    /** A flag indicating whether to ask for membership tier or not. */
    askMembershipTier?: boolean | undefined;
    /** The list of discounts for the quote. */
    discounts?: Discount[] | undefined;
}

/** The contacts gender. */
export enum Gender {
    Male = "Male",
    Female = "Female",
}

/** The contacts title. */
export enum Title {
    Mr = "Mr",
    Mrs = "Mrs",
    Miss = "Miss",
    Ms = "Ms",
    Mx = "Mx",
    Dr = "Dr",
}

/** Contains the payment response details with policy issued. */
export interface PaymentResponse {
    /** The policy number. */
    policyNumber: string;
    /** The receipt number. */
    receiptNumber?: string | undefined;
    /** The total paid. */
    total?: number | undefined;
}

/** Contains membership details regarding the policyholder's. */
export interface UpdateMembershipTierRequest {
    /** The policyholder type. */
    policyholderType?: PolicyholderType | undefined;
    /** The policyholder's membership tier (Specify only for multi match). */
    tier?: MembershipTier | undefined;
}

/** Contains the premium details regarding the quote. */
export interface UpdateMembershipTierResponse extends PremiumDetails {
    /** The list of discounts for the quote. */
    discounts?: Discount[] | undefined;
}

/** Contains the reference data that is required in the payment page. */
export interface PaymentReferenceData {
    /** Publishable Westpac API Key. */
    westpacPublishableApiKey: string;
}

/** Contains the payment details to issue a policy. */
export interface PaymentRequest {
    /** The payment frequency. */
    frequency: PaymentFrequency;
    /** The payment method. */
    method: PaymentMethod;
    /** The accounts BSB number. */
    bsb?: string | undefined;
    /** The account number. */
    accountNumber?: string | undefined;
    /** The account name. */
    accountName?: string | undefined;
    /** The Westpac single use token. */
    token?: string | undefined;
}

/** Object the details of the Model to be run. */
export interface FormotivModelRequest {
    /** The ModelId to run the analysis for. */
    ModelId: string;
    /** The MultiPageToken to run the analysis for. */
    MultiPageToken: string;
}

/** Object the details of the run model response. */
export interface FormotivModel {
    /** The response message. */
    responseMessage: string;
    /** The Formotiv model analysis data. */
    modelData: FormotivModelData;
    /** Indicator of Run Model error response. */
    isError?: boolean | undefined;
}

/** The cover details. */
export interface FormotivModelData {
    /** The probability for prediction of class 1 (positive outcome). */
    score: number;
    /** The real-time data cleaning rules to prepare the data. */
    processor?: string | undefined;
    /** Unique identifier for the deployed real-time model. */
    modelId?: string | undefined;
    /** The development language used to create the model. */
    language: string;
    /** The type of model: Classifier or Regression. */
    type: string;
    /** The amount of time (seconds) to run the prediction. */
    calculationTime: number;
    /** Friendly name of the deployed real-time model. */
    modelName?: string | undefined;
    /** The predicted outcome class. 0 or 1 (negative or positive class). */
    prediction: number;
    /** A number indicating the ranking of the score. */
    ranking?: number | undefined;
    /** If holdouts are disabled for this model, this will always be null. */
    holdout?: boolean | undefined;
}

export class ApiResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}